module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Shopping/Safe-2035522ef0c0314f088ae33f614440048928a6ae7d5fd4fe70079454606b731c.svg";